import { render, staticRenderFns } from "./BursaryListItem.vue?vue&type=template&id=00f2fa1e&"
import script from "./BursaryListItem.vue?vue&type=script&lang=ts&"
export * from "./BursaryListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports